@if (visible()) {
  @if (banner$ | async; as banner) {
    <div class="banner d-print-none" [ngClass]="['justify-content-' + content()]">
      <div class="banner-container" [style.max-width]="maxWidth()">

        @if (withCloseButton()) {
          <div class="banner-close-button" (click)="close()">
            <i class="far fa-window-close"></i>
          </div>
        }

        @if (banner.link) {
          <a [attr.href]="banner.link" target="_blank" rel="noopener noreferrer">
            <img
              class="img-fluid"
              [style.max-height]="maxHeight()"
              [src]="banner.imageUrl"
              [alt]="banner.altText"/>
          </a>
        } @else {
          <img
            class="img-fluid"
            [style.max-height]="maxHeight()"
            [src]="banner.imageUrl"
            [alt]="banner.altText"/>
        }
      </div>
    </div>
  }
}
